import { render, staticRenderFns } from "./ExamPart.vue?vue&type=template&id=1b7e260e&scoped=true"
import script from "./ExamPart.vue?vue&type=script&lang=js"
export * from "./ExamPart.vue?vue&type=script&lang=js"
import style0 from "./ExamPart.vue?vue&type=style&index=0&id=1b7e260e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7e260e",
  null
  
)

export default component.exports